import React, { useMemo } from 'react';
import { Field, Form as FinalForm } from 'react-final-form';
import Form from '../Form/Form';
import css from './UserNativeLang.module.css';
import classNames from 'classnames';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { updateUserLang } from '../../ducks/ui.duck';
import {
  availableLanguages,
  languageSelectOptions,
  USER_LANG_STORAGE_KEY,
} from '../../marketplace-custom-config';
import { updateProfile } from '../../containers/ProfileSettingsPage/ProfileSettingsPage.duck';
import { storeLocalStorageData } from '../../util/data';
import { isRtlLang, setDocumentDirection } from '../../util/document';
import Menu from '../Menu/Menu';
import MenuLabel from '../MenuLabel/MenuLabel';
import MenuContent from '../MenuContent/MenuContent';
import MenuItem from '../MenuItem/MenuItem';
import { InlineTextButton } from '../Button/Button';
import { fetchCurrentUser, updateUserNativeLang } from '../../ducks/user.duck';
import { ReactComponent as GlobeSVG } from '../../assets/svg/globe.svg';
import { sendDataToReactNativeApp } from '../../util/reactnativeAppHelper';

function UserNativeLang(props) {
  const {
    withForm = false,
    name,
    radioInputClassName,
    radioSelectedInputClassName,
    formRootClassName,
    formClassName,
    userNativeLang,
    values = {},
    currentUser,
    onUpdateUserNativeLang,
    onUpdateUserProfile,
    isAuthenticated,
    onFetchCurrentUser,
    ...restProps
  } = props;

  const languages = useMemo(() => Object.values(languageSelectOptions), []);

  const classes = classNames(css.formRoot || formRootClassName, formClassName, {
    [css.disabledForm]: !withForm,
  });
  const fieldSelectedValue = values[name];
  const radioBtnProps = {
    name,
    component: 'input',
    type: 'radio',
  };

  const updateUserLang = value => {
    if (!availableLanguages.has(value)) return;
    onUpdateUserNativeLang(value);
    storeLocalStorageData(USER_LANG_STORAGE_KEY, { lang: value });
    setDocumentDirection(value);
    const promise = isAuthenticated ? onFetchCurrentUser() : updateUserNativeLang(value);
    promise
      .then(() => {
        sendDataToReactNativeApp({
          eventType: 'userNativeLang',
          data: { userNativeLang: value },
        });
      })
      .catch(_ => {});
  };

  const handleOnChange = option => e => {
    e.preventDefault();
    const strValue = option.value;
    updateUserLang(strValue);
  };

  const handleFormSubmit = values => {
    const langValue = values[name];
    updateUserLang(langValue);
  };

  const formInitialValue = { [name]: userNativeLang };

  const isRtl = isRtlLang(userNativeLang);
  const menuContentStyle = isRtl
    ? {
        left: '0px !important',
      }
    : {
        right: '0px !important',
      };
  return withForm ? (
    <FinalForm
      {...restProps}
      initialValues={formInitialValue}
      name={name}
      onSubmit={handleFormSubmit}
      handleFormSubmit={handleFormSubmit}
      radioInputClassName={radioInputClassName}
      radioSelectedInputClassName={radioSelectedInputClassName}
      formRootClassName={classes}
      languages={languages}
      availableLanguages={availableLanguages}
      render={formProps => {
        const {
          handleSubmit,
          handleFormSubmit,
          name,
          values,
          form,
          radioInputClassName,
          radioSelectedInputClassName,
          formRootClassName,
          languages,
          availableLanguages,
        } = formProps;
        const selectedValue = values[name];

        const handleOnChange = e => {
          const strValue = e.target.value;
          if (!availableLanguages.has(strValue)) return;
          form.change(name, strValue);
          // handleSubmit(e);
          handleFormSubmit({ [name]: strValue });
        };

        return (
          <Form onSubmit={e => e.preventDefault()} className={formRootClassName}>
            {languages.map((option, indx) => {
              const formId = `${name}-${option.value}-${indx}`;
              const classes = classNames(css.input, radioInputClassName, {
                [css.selectedInput]: selectedValue === option.value,
                [radioSelectedInputClassName]:
                  selectedValue === option.value && !!radioSelectedInputClassName,
              });
              const label =
                typeof option.label === 'object'
                  ? option.label[userNativeLang] ?? option.label.toString()
                  : option.label;

              return (
                <label key={formId} htmlFor={formId} className={classes}>
                  <Field
                    {...radioBtnProps}
                    id={formId}
                    value={option.value}
                    onChange={handleOnChange}
                  />
                  <span className={css.text}>{label}</span>
                </label>
              );
            })}
          </Form>
        );
      }}
    />
  ) : (
    <Menu leftPositionOffset="0px">
      <MenuLabel className={css.menuLabel}>
        <GlobeSVG />
        {languageSelectOptions[userNativeLang].label}
      </MenuLabel>
      <MenuContent className={css.menuOptions} style={menuContentStyle}>
        {languages.map((option, indx) => {
          const formId = `${name}-${option.value}-${indx}`;
          const classes = classNames(css.input, radioInputClassName, {
            [css.selectedInput]: fieldSelectedValue === option.value,
            [radioSelectedInputClassName]:
              fieldSelectedValue === option.value && !!radioSelectedInputClassName,
          });
          const label =
            typeof option.label === 'object'
              ? option.label[userNativeLang] ?? option.label.toString()
              : option.label;
          return (
            <MenuItem key={option.value} className={css.menuOptn}>
              <InlineTextButton
                onClick={handleOnChange(option)}
                className={classNames(css.menuItemContent, {
                  [css.selectedMenuItemContent]: userNativeLang === option.value,
                })}
              >
                <span className={css.text}>{label}</span>
              </InlineTextButton>
            </MenuItem>
          );
        })}
      </MenuContent>
    </Menu>
  );
}

const mapStateToProps = state => {
  const { userNativeLang } = state.ui;
  const { currentUser } = state.user;
  const { isAuthenticated } = state.auth;
  return { userNativeLang, currentUser, isAuthenticated };
};

const mapDispatchToProps = dispatch => ({
  onUpdateUserNativeLang: lang => dispatch(updateUserLang(lang)),
  onFetchCurrentUser: () => dispatch(fetchCurrentUser()),
  onUpdateUserProfile: payload => dispatch(updateProfile(payload)),
});

export default compose(connect(mapStateToProps, mapDispatchToProps))(UserNativeLang);
